// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IEventReviewRequest {
	isValidAlert: boolean | undefined;

	notes: string | undefined;

	$type?: string | undefined;
}
export class EventReviewRequest {
	constructor(data?: IEventReviewRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	isValidAlert: boolean | undefined;

	notes: string | undefined;

	static $type: string = "CoreApi.Models.EventReviewRequest, ";
	$type?: string | undefined = EventReviewRequest.$type;
}

